import { useEffect } from "react";

const SITE = "Gillspotter";
// Keep in step with the description in index.html.
const DEFAULT_DESCRIPTION =
  "Whale shark photo-identification. Upload a photograph: Gillspotter reads the spots behind the " +
  "gills, matches them as a constellation against 3,000 known sharks, and shows you the evidence.";

function setMeta(attr: "name" | "property", key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

export interface DocumentMeta {
  title?: string;
  description?: string;
  image?: string;
}

/** Set the tab title and the description / Open Graph tags for the current page. */
export function useDocumentMeta({ title, description, image }: DocumentMeta): void {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — whale sharks, known by their stars`;
    const desc = description ?? DEFAULT_DESCRIPTION;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", new URL(image, window.location.origin).href);
  }, [title, description, image]);
}
